import { deviceDetect, deviceType, isMobile } from "react-device-detect";

export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
}

async function readTextSafe(res: Response) {
  try {
    const t = await res.text();
    return t?.trim() || "";
  } catch {
    return "";
  }
}

function buildApiUrl(path: string, query?: Record<string, string | number | undefined | null>) {
  const url = new URL(path, window.location.origin);
  if (query) {
    for (const [k, v] of Object.entries(query)) {
      if (v === undefined || v === null || v === "") continue;
      url.searchParams.set(k, String(v));
    }
  }
  return url.toString();
}

export async function checkConfigIdService(configId: string) {
  if (!configId?.trim()) {
    throw new Error("configId fehlt");
  }

  const url = buildApiUrl("/api/check", { configId });

  const res = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "text/plain"
    }
  });

  if (!res.ok) {
    const msg = await readTextSafe(res);
    throw new ApiError(res.status, msg || `Check fehlgeschlagen (${res.status})`);
  }

  return res;
}

export async function sendFeedbackService(feedback: Rating.Feedback, apiKey?: string) {
  if (!feedback?.configId?.trim()) {
    throw new Error("configId fehlt");
  }

  const device = deviceDetect("");
  const dimensions = getWindowDimensions();

  const data = {
    comment: feedback.comment,
    rating: feedback.rating,
    externalId: "",
    regionId: "",
    browser: device.browserName,
    browserVersion: device.browserMajorVersion,
    os: device.osName,
    osVersion: device.osVersion,
    deviceType: deviceType,
    resizeHeight: String(dimensions.height),
    resizeWidth: String(dimensions.width),
    touch: isMobile,
    locale: window.navigator.language,
    url: window.location.hostname,
    test: feedback.test,
    timestamp: Date.now(),
    customData: {
      test: "test"
    }
  };

  const url = buildApiUrl("/api/rate", { configId: feedback.configId });

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    Accept: "text/plain"
  };
  if (apiKey) {
    headers["x-api-key"] = apiKey;
  }

  const res = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify(data)
  });

  if (!res.ok) {
    const msg = await readTextSafe(res);
    throw new ApiError(res.status, msg || `Rating fehlgeschlagen (${res.status})`);
  }

  return res;
}
